import type { IValidatedResponse } from '../../httpClient';
import { getRequest } from '../../httpClient';
import type { IListPeopleParams } from './list-people-request';
import type { IListPeopleResponse } from './list-people-response';
import { listPeopleResponseSchema } from './list-people-response';

export async function listPeopleApi(
  params: IListPeopleParams = {},
): Promise<IValidatedResponse<IListPeopleResponse>> {
  const query = new URLSearchParams();
  if (params.limit !== undefined) {
    query.set('limit', String(params.limit));
  }
  if (params.offset !== undefined) {
    query.set('offset', String(params.offset));
  }
  if (params.search) {
    query.set('search', params.search);
  }
  const suffix = query.toString();
  return getRequest<IListPeopleResponse>({
    path: `/sys/people/v1${suffix ? `?${suffix}` : ''}`,
    schema: listPeopleResponseSchema,
  });
}
